
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms-guides",
      function () {
        return require("private-next-pages/forms-guides/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms-guides"])
      });
    }
  